export default "__VITE_ASSET__DFDSjCCE__"